import { useMutation } from "react-query";
import downloadPaymentsListingCSV from "../services/downloadPaymentsListingCSV";

function useDownloadPaymentsListingCSV() {
  return useMutation(
    ["downloadPaymentsListingCSV"],
    downloadPaymentsListingCSV
  );
}

export default useDownloadPaymentsListingCSV;
